export default __webpack_public_path__ + "static/phone-015db6e79b4b515ea7af89bed620f0ec.svg";